// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:30:46.185Z
// Property: Pala Mesa (ID: 6767906449167151)
// Collections: 23 amenities, 3 floorplans (live), 23 photos, 43 POIs, 4 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167151",
  "property_external_id": "1125098",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/pala-mesa-mesa-az/pd2m49t/",
  "property_google_business_url": "https://www.google.com/maps/place/Pala+Mesa/data=!4m2!3m1!1s0x0:0x4257659b0f6fa610?sa=X&ved=2ahUKEwjdvoaa2oOTAxXVhIkEHevwKg8Q_BJ6BAgNEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47568032099",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "pala-mesa",
  "property_name": "Pala Mesa",
  "property_website_url": "https://www.palamesaapartments.com",
  "property_domain": "https://www.palamesaapartments.com",
  "property_address": "2433 West Main Street",
  "property_full_address": "2433 West Main Street, Mesa, AZ, 85201",
  "property_address_1": "2433 West Main Street",
  "property_address_2": null,
  "property_address_city": "Mesa",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85201",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Central Mesa",
  "property_address_latitude": "33.4145",
  "property_address_longitude": "-111.884",
  "property_email": "palamesa@weidner.com",
  "property_phone": "9283930513",
  "property_call_tracking_phone": "623-428-0007",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Pala Mesa, where modern living meets comfort in vibrant Mesa, AZ. Our thoughtfully designed one- and two-bedroom apartments feature sleek kitchens, walk-in closets, and community perks like a gym, pool, and pet-friendly spaces. Ready to elevate your lifestyle? Browse our availability or schedule a tour today!",
  "property_long_description": "**Discover Your Perfect Home at Pala Mesa, Mesa, AZ**\n\nWelcome to Pala Mesa, where comfort meets convenience in the heart of Mesa, Arizona. Our charming apartment community offers a variety of thoughtfully designed floor plans, including one and two-bedroom options, tailored to suit your lifestyle. Each apartment features modern amenities such as high-speed internet access, air conditioning, and fully equipped kitchens with updated appliances, ensuring you'll feel right at home.\n\nAt Pala Mesa, we prioritize your comfort and convenience. Our dedicated property management team is on-site to assist with online maintenance requests, while our 24-hour maintenance staff is always ready to ensure everything runs smoothly. Enjoy a smoke-free environment and take advantage of our gated community for added peace of mind. \n\nUnwind in our resort-style amenities, which include a sparkling pool, spa, and state-of-the-art fitness center, perfect for your wellness journey. For pet lovers, our dog park and pet play area provide ample space for your furry friends to roam free. You can also take advantage of our package service and covered parking options for added convenience.\n\nConnect with your neighbors at our BBQ grilling area or relax in the comfort of your apartment with stylish accent walls and spacious walk-in closets. With online payments and the Cox Quick Connect service, managing your home has never been easier. \n\nFind your new home today at Pala Mesa—browse our availability or schedule a tour to experience our vibrant community firsthand! Your ideal lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c2-1117-716a-8395-d79f82c74c70.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool area with lounge chairs, umbrellas, and a table with chairs.",
    "public_id": "019d08c2-1117-716a-8395-d79f82c74c70",
    "storage_key": "property/6767906449167151/019d08c2-1117-716a-8395-d79f82c74c70.webp",
    "width": 1024,
    "height": 374
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "256",
  "property_year_built": "1999",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.484375",
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": "300-400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Max 2 pets per unit; some small pets (hamsters, birds, turtles, fish, reptiles) allowed without fees, with restrictions (e.g., max two birds, 20-gal tank for fish).",
  "property_pet_policy_description": "Cats & dogs are welcome (no weight limit). Max 2 pets per unit. Monthly pet rent: $25 per pet. Non‑refundable pet fee: $200 per pet. Refundable pet deposit: $200 per pet. Some small pets (hamsters, birds, turtles, fish, reptiles) allowed without fees; restrictions apply (e.g., max two birds, 20‑gal tank for fish).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://palamesaapartments.securecafe.com/onlineleasing/pala-mesa-0/floorplans.aspx",
  "property_resident_portal_url": "https://palamesaapartments.securecafe.com/residentservices/pala-mesa-0/userlogin.aspx",
  "property_apply_now_url": "https://palamesaapartments.securecafe.com/onlineleasing/pala-mesa-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c2-1bef-74ff-ab83-58355cefc4c8.webp",
  "property_primary_logo_media": {
    "alt_text": "Pala Mesa Apartment Homes logo",
    "public_id": "019d08c2-1bef-74ff-ab83-58355cefc4c8",
    "storage_key": "property/6767906449167151/019d08c2-1bef-74ff-ab83-58355cefc4c8.webp",
    "width": 212,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c2-289d-714d-bfd0-9cd946103499.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Pala Mesa Apartment Homes logo",
    "public_id": "019d08c2-289d-714d-bfd0-9cd946103499",
    "storage_key": "property/6767906449167151/019d08c2-289d-714d-bfd0-9cd946103499.webp",
    "width": 212,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c2-3279-7210-9a72-30985281dcbe.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Pala Mesa Apartment Homes logo.",
    "public_id": "019d08c2-3279-7210-9a72-30985281dcbe",
    "storage_key": "property/6767906449167151/019d08c2-3279-7210-9a72-30985281dcbe.webp",
    "width": 212,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#a3abac",
  "property_secondary_color": "#5f6a6c",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#e8e8e4",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 952",
  "property_sqft_min": "715",
  "property_sqft_max": "952",
  "property_price_range": "1140 - 2140",
  "property_price_min": "1140",
  "property_price_max": "2140",
  "property_available_units": 12,
  "property_facebook_url": "https://www.facebook.com/PalaMesaApartments/",
  "property_instagram_url": "https://www.instagram.com/palamesaapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJz1suhGoIK4cREKZvD5tlV0I",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pala Mesa",
  "property_home_romance_title": "Embrace a Life You’ll Love at Our Apartment Community",
  "property_home_amenities_blurb": "Welcome to Pala Mesa in sunny Mesa, AZ, where modern living meets comfort. Enjoy spacious one and two-bedroom apartments with luxurious amenities like a refreshing pool, fitness center, and pet-friendly spaces. Embrace a smoke-free lifestyle, complete with package service and online payments. Your serene oasis awaits!",
  "property_home_floorplans_blurb": "At Pala Mesa in vibrant Mesa, AZ, your ideal living space awaits. With a variety of thoughtfully designed floor plans, each apartment offers the perfect blend of comfort and style. Browse our available homes today and see how Pala Mesa can elevate your lifestyle in the heart of Arizona.",
  "property_home_gallery_blurb": "At Pala Mesa in sunny Mesa, AZ, our vibrant apartment community offers spacious one- and two-bedroom floor plans, complete with modern amenities. Enjoy a refreshing dip in the pool, break a sweat in the fitness center, or unwind at the spa. Picture yourself living here, surrounded by comfort and convenience!",
  "property_home_neighborhood_blurb": "At Pala Mesa in Mesa, AZ, your ideal home awaits in spacious one and two-bedroom floor plans. Nestled near renowned schools like Webster Elementary and Westwood High, our community offers the perfect blend of comfort and convenience. See what's around our community and explore local favorites and nearby points of interest.",
  "property_home_reviews_blurb": "At Pala Mesa in Mesa, AZ, residents rave about their vibrant community spirit, with one stating, “The friendly atmosphere makes every day feel like home.” Experience our inviting spaces, exceptional amenities, and a welcoming vibe. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the heart of Mesa, AZ, Pala Mesa offers seamless access to premier educational institutions like Webster Elementary and Franklin Accelerated Academy. With a vibrant community and nearby enriching spots such as The Aces and Children First Academy, every day is an opportunity for growth and discovery. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Pala Mesa in the heart of Mesa, AZ, luxury meets convenience. Enjoy sunny days at the pool, unwind in the spa, or stay active at our fitness center. With pet-friendly spaces, modern appliances, and online amenities, your ideal lifestyle is waiting. Live where comfort and community come together!",
  "property_applynow_blurb": "At Pala Mesa in Mesa, AZ, you’ll find a vibrant community where modern living meets convenience. Enjoy spacious one and two-bedroom layouts, a refreshing pool, and a well-equipped fitness center. With pet-friendly amenities and online leasing options, your ideal home awaits—apply today and embrace a lifestyle of comfort!",
  "property_contactus_blurb": "At Pala Mesa in sunny Mesa, AZ, choose from our stylish one-bedroom and spacious two-bedroom floor plans designed for modern living. Each apartment reflects comfort and convenience. Have questions? Reach out to our leasing team today and let’s find the perfect home for you!",
  "property_faqs_blurb": "At Pala Mesa in vibrant Mesa, AZ, our thoughtfully designed one and two-bedroom apartments offer comfort and style. Have questions about our community? Our FAQs page is brimming with insights to help you feel right at home. Check it out, and unlock the possibilities today!",
  "property_floorplans_blurb": "At Pala Mesa in Mesa, AZ, our diverse floor plans cater to your lifestyle, whether you're seeking a cozy one-bedroom retreat or a spacious two-bedroom home. Uncover the ideal layout that resonates with your vision of comfort. Browse our available apartment homes and find your perfect floor plan today!",
  "property_gallery_blurb": "At Pala Mesa in vibrant Mesa, AZ, enchanting one and two-bedroom floor plans await your personal touch. Revel in premier amenities, from a relaxing pool and fitness center to a welcoming dog park. Picture yourself living here, where every detail is designed for comfort and community.",
  "property_interactivemap_blurb": "At Pala Mesa in vibrant Mesa, AZ, embrace a lifestyle brimming with comfort and convenience. Our community features spacious one and two-bedroom floor plans and an array of amenities—from a refreshing pool and fitness center to a pet-friendly dog park. Navigate your future home effortlessly with our interactive community map!",
  "property_pets_blurb": "At Pala Mesa in sunny Mesa, AZ, your furry friends find their new home too! With no weight limits and space for up to two pets per unit, our community is perfect for families who love to bring their pets along. Enjoy nearby parks and pet-friendly amenities!",
  "property_referafriend_blurb": "At Pala Mesa in sunny Mesa, AZ, your perfect home awaits in our inviting one and two-bedroom floor plans. With a vibrant community spirit, we celebrate the connections we create. Great friends make great neighbors—refer a friend today and share the joy of living at Pala Mesa!",
  "property_residentaccess_blurb": "Welcome to Pala Mesa in sunny Mesa, AZ! Our vibrant one-bedroom and spacious two-bedroom floor plans are designed for your comfort. Maximize your living experience by accessing your resident portal—pay rent, schedule maintenance, and connect with our community effortlessly. Dive into hassle-free living at Pala Mesa today!",
  "property_reviews_blurb": "At Pala Mesa in beautiful Mesa, AZ, residents rave about the welcoming vibe and friendly neighbors, with one stating, “The sense of community here is unparalleled.” Don’t just take their word for it; see what our residents have to say about living at our vibrant community!",
  "property_created_at": "1771530706100",
  "property_scheduletour_blurb": "At Pala Mesa in Mesa, AZ, choose from spacious one or two-bedroom floor plans designed for comfort and style. Picture your life in a vibrant community where every detail is curated for you. Curious about resident experiences? Schedule a tour and hear their stories firsthand!",
  "property_thankyou_blurb": "Thank you for reaching out to Pala Mesa in vibrant Mesa, AZ! Our inviting one- and two-bedroom floor plans offer the perfect blend of style and comfort. A member of our team will be in touch soon to assist you in finding your ideal new home. Your journey begins here!",
  "property_virtualtours_blurb": "Welcome to Pala Mesa in vibrant Mesa, AZ, where modern living meets comfort. Our thoughtfully designed one and two-bedroom floor plans offer a perfect sanctuary for any lifestyle. Join us online for a virtual tour and envision your new home, complete with stunning views and inviting spaces!",
  "property_copyright": "2026 All Rights Reserved. Pala Mesa",
  "property_seo_title_home": "Pala Mesa |  Apartments in Mesa, AZ",
  "property_seo_description_home": "Discover vibrant living at Pala Mesa, Mesa, AZ! Choose from modern one or two-bedroom apartments in a welcoming community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Mesa, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Pala Mesa in Mesa, AZ! Choose from stylish one and two-bedroom floor plans. Your perfect space awaits—start browsing today!",
  "property_seo_title_amenities": "Amenities | Mesa, AZ Apartments for Rent",
  "property_seo_description_amenities": "Experience a vibrant lifestyle at Pala Mesa in Mesa, AZ! Enjoy a pool, fitness center, pet-friendly spaces, and modern comforts in our inviting community.",
  "property_seo_title_gallery": "Gallery | Apartments in Mesa, AZ",
  "property_seo_description_gallery": "Picture your life at Pala Mesa in Mesa, AZ! Modern amenities, spacious floor plans, and a pet-friendly vibe await. Your dream home is just a click away!",
  "property_seo_title_virtualtours": "Virtual Tours | Pala Mesa Apartments",
  "property_seo_description_virtualtours": "Experience Pala Mesa in Mesa, AZ! Take a virtual tour of our inviting one and two-bedroom apartments today and envision your new home.",
  "property_seo_title_interactivemap": "Interactive Map | Pala Mesa Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Pala Mesa in Mesa, AZ! Use our interactive map to explore one and two-bedroom apartments with top-notch amenities and easy access.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mesa, AZ",
  "property_seo_description_neighborhood": "Uncover the vibrant lifestyle around Pala Mesa in Mesa, AZ! From local favorites to hidden gems, dive into the community and enhance your experience.",
  "property_seo_title_contact": "Contact Us | Pala Mesa",
  "property_seo_description_contact": "Connect with our friendly leasing team at Pala Mesa in Mesa, AZ. Inquire about our unique one and two-bedroom floor plans tailored for your lifestyle!",
  "property_seo_title_faqs": "FAQs | Apartments in Mesa, AZ",
  "property_seo_description_faqs": "Get the answers you need about Pala Mesa in Mesa, AZ! Visit our FAQs for details on amenities, floor plans, and community living. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mesa, AZ",
  "property_seo_description_reviews": "Uncover the voices of Pala Mesa residents! Experience unrivaled amenities and vibrant living in Mesa, AZ. See why they love calling it home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Mesa, AZ",
  "property_seo_description_applynow": "Discover your ideal living at Pala Mesa, Mesa, AZ. Enjoy modern amenities, beautiful floor plans, and a smoke-free lifestyle. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Pala Mesa",
  "property_seo_description_residentaccess": "Elevate your Pala Mesa living experience. Log in to your resident portal for easy rent payments, maintenance requests, and community updates in Mesa, AZ!",
  "property_seo_title_referafriend": "Refer A Friend | Pala Mesa",
  "property_seo_description_referafriend": "Great friends make great neighbors at Pala Mesa! Refer a friend today and enjoy the vibrant community of Mesa, AZ. Join us for a life well-lived!",
  "property_seo_title_scheduletour": "Schedule a Tour | Pala Mesa",
  "property_seo_description_scheduletour": "Step into modern living at Pala Mesa in Mesa, AZ. Your dream apartment awaits—schedule a tour today and experience vibrant community life!",
  "property_seo_title_privacy": "Privacy Policy | Pala Mesa",
  "property_seo_description_privacy": "At Pala Mesa, Mesa, AZ, your privacy is a priority. Discover how we safeguard your information while you enjoy exceptional living.",
  "property_seo_title_accessibility": "Website Accessibility | Pala Mesa",
  "property_seo_description_accessibility": "At Pala Mesa in Mesa, AZ, we prioritize digital accessibility for everyone. Experience inclusive living with us—your needs matter! Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Pala Mesa",
  "property_seo_description_sitemap": "Navigate Pala Mesa in Mesa, AZ! Find your perfect apartment home and discover community features that suit your lifestyle. Check out our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Pala Mesa",
  "property_seo_description_thankyou": "Thank you for sharing your info! The Pala Mesa team will reach out soon to help you find your perfect home in beautiful Mesa, AZ. Exciting possibilities await!",
  "property_seo_title_pets": "Pet Policy | Apartments in Mesa, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793057363151",
  "amenities": [
    {
      "id": "ec_ab3f2107b6115267fb7177e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564838",
      "title": "24 Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d9a3b-ef5b-72ef-839e-05e0ca1717a8.webp",
      "amenity_image_media": {
        "alt_text": "A well-equipped fitness center with treadmills, ellipticals, stationary bikes, and a weight machine.",
        "public_id": "019d9a3b-ef5b-72ef-839e-05e0ca1717a8",
        "storage_key": "property/6767906449167151/019d9a3b-ef5b-72ef-839e-05e0ca1717a8.webp",
        "width": 1024,
        "height": 685
      },
      "amenity_image_alt_text": "a gym with treadmills and other exercise equipment,the apartments fitness room,the gym at the apartments for rent",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a19e70d13ca0441074ad9dd2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564840",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc9230d3a378196cc550501f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564842",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53d39bb21a005def59db81f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564845",
      "title": "Limited Access Gated Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_342e85e02da371472ac8a587",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564848",
      "title": "On Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7803eb49f11e5ec87eb96dea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564850",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d9a3b-f1e8-738c-9a7e-ef005e4a2134.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool and spa with lounge chairs and palm trees.",
        "public_id": "019d9a3b-f1e8-738c-9a7e-ef005e4a2134",
        "storage_key": "property/6767906449167151/019d9a3b-f1e8-738c-9a7e-ef005e4a2134.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "our apartments offer a swimming pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1524e7b582da75ea1ec840f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564851",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc92dba6fb3cb7f704e37918",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564837",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Free e-check option\r\nAccepts credit card payments\r\nAccepts cash payments via MoneyGram",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_300de8924af90a4eb06f0659",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564839",
      "title": "Dog Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_101544089bdc2ec4e5f3fbec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564844",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d3f0d9ada48c3a576e085c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564846",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d981e127edbca432951ad63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564847",
      "title": "Online Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db38f777979f52b2b676a7ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "88069601",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62179da267adfe0ea6e333cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564853",
      "title": "Ceiling Fan*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d9a3b-ef65-76ab-a93e-4d62ade34243.webp",
      "amenity_image_media": {
        "alt_text": "Living room with a couch, coffee table, and window.",
        "public_id": "019d9a3b-ef65-76ab-a93e-4d62ade34243",
        "storage_key": "property/6767906449167151/019d9a3b-ef65-76ab-a93e-4d62ade34243.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e6702ba0545ea8393c70709",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564855",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d9a3b-ef64-7733-92ff-5629c3983d48.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white appliances, light wood cabinets, and a countertop with wine glasses and bottles.",
        "public_id": "019d9a3b-ef64-7733-92ff-5629c3983d48",
        "storage_key": "property/6767906449167151/019d9a3b-ef64-7733-92ff-5629c3983d48.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6a1960d455cc912e6a2248c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564856",
      "title": "Full size Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d9a3b-ef63-764c-956d-cd0dbd7cd57e.webp",
      "amenity_image_media": {
        "alt_text": "In-unit washer and dryer",
        "public_id": "019d9a3b-ef63-764c-956d-cd0dbd7cd57e",
        "storage_key": "property/6767906449167151/019d9a3b-ef63-764c-956d-cd0dbd7cd57e.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68d8900d81259e145c27cdd5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564857",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f3a7d16bbb33158846f8d8e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564858",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d36f387ffdd8c220001d6b79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564859",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e06204892470e9263baa5354",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564860",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3aa7041389b0a59eae23dd38",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "87564854",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a1bf2f36551e4425d533a08",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "123224202",
      "title": "Spectrum Quick Connect",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4f9e1473a86f8f725ff17e3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "yardi",
      "external_id": "122165676",
      "title": "Updated appliance*",
      "amount": "false",
      "description": "select apartment homes only",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_15b7711e2c4e6cee1138a10b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-04ea-721d-8935-8cf8a87cbb5e.webp",
      "image_media": {
        "alt_text": "Resort-style pool and hot tub with lounge chairs and palm trees.",
        "public_id": "019d0218-04ea-721d-8935-8cf8a87cbb5e",
        "storage_key": "property/6767906449167151/019d0218-04ea-721d-8935-8cf8a87cbb5e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style pool and soothing hot tub, surrounded by lush palm trees and comfortable lounge seating.",
      "link": "false",
      "alt_text": "Resort-style pool and hot tub with lounge chairs and palm trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (16).jpg"
    },
    {
      "id": "ec_24b472dc4307e98dad33ea37",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-9560-7429-9cf7-a652814cc518.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, and accent chairs.",
        "public_id": "01a17a78-9560-7429-9cf7-a652814cc518",
        "storage_key": "property/6767906449167151/01a17a78-9560-7429-9cf7-a652814cc518.webp",
        "width": 2560,
        "height": 1701
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a plush sofa, comfortable accent chairs, and a stylish coffee table, perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, and accent chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (1).jpg"
    },
    {
      "id": "ec_4d0a09b84e6f6c8224fc5466",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-9540-70e6-bad7-4499e6b0b3a1.webp",
      "image_media": {
        "alt_text": "Living room with white sofa, coffee table, and wall art.",
        "public_id": "01a17a78-9540-70e6-bad7-4499e6b0b3a1",
        "storage_key": "property/6767906449167151/01a17a78-9540-70e6-bad7-4499e6b0b3a1.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable white sofa, a modern coffee table, and tasteful wall art. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with white sofa, coffee table, and wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (2).jpg"
    },
    {
      "id": "ec_ddae05a508f2479444c77f14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-952a-76f8-910d-a02e70ed3746.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs, open to a kitchen with white cabinets.",
        "public_id": "01a17a78-952a-76f8-910d-a02e70ed3746",
        "storage_key": "property/6767906449167151/01a17a78-952a-76f8-910d-a02e70ed3746.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Enjoy elegant dining in your spacious apartment, featuring an open-concept layout connecting to a modern kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Dining area with a round table and chairs, open to a kitchen with white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (3).jpg"
    },
    {
      "id": "ec_d02872ff3b80e22be758b1ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-99d6-728a-8893-491ea5f47d5c.webp",
      "image_media": {
        "alt_text": "Dining area with a glass-top table set for four, adjacent to a bedroom and a balcony.",
        "public_id": "01a17a78-99d6-728a-8893-491ea5f47d5c",
        "storage_key": "property/6767906449167151/01a17a78-99d6-728a-8893-491ea5f47d5c.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a glass-top table with place settings for four, a large decorative mirror, and views into a bedroom and a balcony. Perfect for intimate meals.",
      "link": "false",
      "alt_text": "Dining area with a glass-top table set for four, adjacent to a bedroom and a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (4).jpg"
    },
    {
      "id": "ec_0d6641be5dfb9658a2fbb656",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-954e-77db-aa11-f32e8cc02b29.webp",
      "image_media": {
        "alt_text": "Kitchen and breakfast bar with stools, leading to a bedroom.",
        "public_id": "01a17a78-954e-77db-aa11-f32e8cc02b29",
        "storage_key": "property/6767906449167151/01a17a78-954e-77db-aa11-f32e8cc02b29.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious kitchen with ample cabinet space and a breakfast bar, perfect for casual dining. Adjacent bedroom offers a comfortable retreat.",
      "link": "false",
      "alt_text": "Kitchen and breakfast bar with stools, leading to a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (5).jpg"
    },
    {
      "id": "ec_1aa66f5f81502b8ea68e7004",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-a776-7538-ae28-dd2755962cb5.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances including a refrigerator, oven, and microwave, and a window overlooking trees.",
        "public_id": "01a17a78-a776-7538-ae28-dd2755962cb5",
        "storage_key": "property/6767906449167151/01a17a78-a776-7538-ae28-dd2755962cb5.webp",
        "width": 2560,
        "height": 1701
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring light wood cabinetry, a full suite of black appliances, ample counter space, and a window providing natural light and a view of the surrounding greenery.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, black appliances including a refrigerator, oven, and microwave, and a window overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (6).jpg"
    },
    {
      "id": "ec_397e410ff7ea773e58a333b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-a6f7-73b7-92aa-a3d8b162178b.webp",
      "image_media": {
        "alt_text": "Kitchen with white countertops, black appliances, and ample cabinet space.",
        "public_id": "01a17a78-a6f7-73b7-92aa-a3d8b162178b",
        "storage_key": "property/6767906449167151/01a17a78-a6f7-73b7-92aa-a3d8b162178b.webp",
        "width": 2560,
        "height": 1701
      },
      "title": "Apartment",
      "description": "A modern kitchen featuring white countertops, a double sink, a black microwave, oven, and refrigerator. Ample cabinet space provides storage.",
      "link": "false",
      "alt_text": "Kitchen with white countertops, black appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (7).jpg"
    },
    {
      "id": "ec_c5526b24966b02af8233f1d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-a7e4-7320-99c5-e8081c41d74a.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, light wood cabinets, and butcher block countertops.",
        "public_id": "01a17a78-a7e4-7320-99c5-e8081c41d74a",
        "storage_key": "property/6767906449167151/01a17a78-a7e4-7320-99c5-e8081c41d74a.webp",
        "width": 2560,
        "height": 1701
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring white appliances, ample cabinet space, and a clean countertop, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with white appliances, light wood cabinets, and butcher block countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (8).jpg"
    },
    {
      "id": "ec_34dfc7956a493b03cb344113",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0217-ea53-712f-8b14-b579b4c109dc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, white appliances, and stainless steel sink.",
        "public_id": "019d0217-ea53-712f-8b14-b579b4c109dc",
        "storage_key": "property/6767906449167151/019d0217-ea53-712f-8b14-b579b4c109dc.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this well-appointed kitchen, featuring ample cabinet space, a double sink, and modern appliances. Perfect for preparing meals and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, white appliances, and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (9).jpg"
    },
    {
      "id": "ec_02a72b1ad3779cfa7e79b644",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-a935-7256-ae0b-4e0637c5815d.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "01a17a78-a935-7256-ae0b-4e0637c5815d",
        "storage_key": "property/6767906449167151/01a17a78-a935-7256-ae0b-4e0637c5815d.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Relax in our spacious bedrooms, designed for comfort and tranquility. Featuring plush bedding, elegant decor, and ample natural light.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (10).jpg"
    },
    {
      "id": "ec_a706063cc402d8826ffb5cd8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-ae10-712a-adf8-015e1efbad82.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and en-suite bathroom.",
        "public_id": "01a17a78-ae10-712a-adf8-015e1efbad82",
        "storage_key": "property/6767906449167151/01a17a78-ae10-712a-adf8-015e1efbad82.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious bedroom, complete with a walk-in closet and an attached full bathroom. Enjoy ample storage and a private oasis.",
      "link": "false",
      "alt_text": "Bedroom with closet and en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (11).jpg"
    },
    {
      "id": "ec_d8cb9528443f6c69f806351e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0217-f23a-76e3-ac4b-42ed0609b82e.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, a large mirror, and a closet.",
        "public_id": "019d0217-f23a-76e3-ac4b-42ed0609b82e",
        "storage_key": "property/6767906449167151/019d0217-f23a-76e3-ac4b-42ed0609b82e.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom featuring a plush queen-size bed, elegant decor, and ample closet space.",
      "link": "false",
      "alt_text": "Cozy bedroom with a queen-size bed, decorative pillows, a large mirror, and a closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (12).jpg"
    },
    {
      "id": "ec_226ee7a2b97c93d8ea2609c6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0217-f6a4-772e-9b80-780f08100643.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, and decorative mirror.",
        "public_id": "019d0217-f6a4-772e-9b80-780f08100643",
        "storage_key": "property/6767906449167151/019d0217-f6a4-772e-9b80-780f08100643.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a plush bed, a stylish nightstand with a lamp, and a decorative mirror on the wall, creating a cozy atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a bed, nightstand, and decorative mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (13).jpg"
    },
    {
      "id": "ec_6da7946a9e8e8d19aabe5301",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-b9ba-73eb-b69a-b41ce0ebcac5.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
        "public_id": "01a17a78-b9ba-73eb-b69a-b41ce0ebcac5",
        "storage_key": "property/6767906449167151/01a17a78-b9ba-73eb-b69a-b41ce0ebcac5.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a bathtub/shower combo, toilet, and a vanity with a sink and ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (14).jpg"
    },
    {
      "id": "ec_6d60badc47e73354926b5f8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-bb43-76b4-aac8-2b8b3407da86.webp",
      "image_media": {
        "alt_text": "In-unit laundry area with washer and dryer",
        "public_id": "01a17a78-bb43-76b4-aac8-2b8b3407da86",
        "storage_key": "property/6767906449167151/01a17a78-bb43-76b4-aac8-2b8b3407da86.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities featuring a full-sized washer and dryer, with shelving above for storage and decor.",
      "link": "false",
      "alt_text": "In-unit laundry area with washer and dryer",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (15).jpg"
    },
    {
      "id": "ec_f03e473a318c9b1b272056ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-bd64-723f-9f39-6ad7acb28a8c.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a17a78-bd64-723f-9f39-6ad7acb28a8c",
        "storage_key": "property/6767906449167151/01a17a78-bd64-723f-9f39-6ad7acb28a8c.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style swimming pool, surrounded by comfortable lounge chairs and shaded by vibrant umbrellas. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (17).jpg"
    },
    {
      "id": "ec_8c3990087754016dcb18b454",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-05ea-77ed-aaa7-635cab8b5d34.webp",
      "image_media": {
        "alt_text": "Modern lobby area with comfortable seating and decor.",
        "public_id": "019d0218-05ea-77ed-aaa7-635cab8b5d34",
        "storage_key": "property/6767906449167151/019d0218-05ea-77ed-aaa7-635cab8b5d34.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lobby, featuring plush seating and contemporary decor. A welcoming space for residents and guests.",
      "link": "false",
      "alt_text": "Modern lobby area with comfortable seating and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (19).jpg"
    },
    {
      "id": "ec_c1719bd253eed6514fec76b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a17a78-bcb8-758c-b6b0-ffba889a539a.webp",
      "image_media": {
        "alt_text": "Comfortable seating area in the property's spacious lobby with large windows and modern decor.",
        "public_id": "01a17a78-bcb8-758c-b6b0-ffba889a539a",
        "storage_key": "property/6767906449167151/01a17a78-bcb8-758c-b6b0-ffba889a539a.webp",
        "width": 2560,
        "height": 1440
      },
      "title": "Community",
      "description": "Welcome to our inviting lobby, designed for comfort and style. Relax in our plush seating areas while you admire the modern decor and natural light filtering through the large windows.",
      "link": "false",
      "alt_text": "Comfortable seating area in the property's spacious lobby with large windows and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites HR (20).jpg"
    },
    {
      "id": "ec_986acf83b89ca4e984d2ed9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a179d3-5409-7533-ac15-d379678314c0.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight benches, and free weights.",
        "public_id": "01a179d3-5409-7533-ac15-d379678314c0",
        "storage_key": "property/6767906449167151/01a179d3-5409-7533-ac15-d379678314c0.webp",
        "width": 1024,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of cardio machines, weight benches, and free weights to help you reach your fitness goals.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight benches, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/E70E34E3-6915-4093-9466-D5482385BC6B.PNG"
    },
    {
      "id": "ec_61308dbd8c2f7fbe70458fe7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/01a179d3-541a-7019-b3ae-f370bee967c7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment.",
        "public_id": "01a179d3-541a-7019-b3ae-f370bee967c7",
        "storage_key": "property/6767906449167151/01a179d3-541a-7019-b3ae-f370bee967c7.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and weight training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, and weight training equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/84A01AEF-FE3A-4E3C-9281-E81B6E3B5C27.PNG"
    },
    {
      "id": "ec_8aafd5015e027a37fc84022d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-138f-73b3-af4f-c9715e356e9e.webp",
      "image_media": {
        "alt_text": "Large, well-maintained grassy area with trees and fencing.",
        "public_id": "019d0218-138f-73b3-af4f-c9715e356e9e",
        "storage_key": "property/6767906449167151/019d0218-138f-73b3-af4f-c9715e356e9e.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy our beautiful, expansive green space perfect for recreation and relaxation.",
      "link": "false",
      "alt_text": "Large, well-maintained grassy area with trees and fencing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (21).jpg"
    },
    {
      "id": "ec_d6de5bdc451bfb75600806f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-18c6-720b-8a42-a88a894f926e.webp",
      "image_media": {
        "alt_text": "Pala Mesa Apartment Homes monument sign with address 2433.",
        "public_id": "019d0218-18c6-720b-8a42-a88a894f926e",
        "storage_key": "property/6767906449167151/019d0218-18c6-720b-8a42-a88a894f926e.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome to Pala Mesa Apartment Homes, located at 2433. This monument sign is located near a street with a tram line and palm trees.",
      "link": "false",
      "alt_text": "Pala Mesa Apartment Homes monument sign with address 2433.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Pala-Mesa_Favorites (22).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fa7d11e0-002d-4a2f-9c41-72d9c1d054d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "920 E Playa Del Norte Dr, Tempe, AZ 85288, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including the Double Double and Protein Style options, and fresh-cut fries. They highlight the affordable prices and the consistently good quality of the food. They also like the friendly and efficient service.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://locations.in-n-out.com/195",
      "poi_directions_map_url": "https://maps.google.com/?cid=489587622613132376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "33.4348998",
      "poi_longitude": "-111.925444",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9435-7441-b70b-790942724446",
        "storage_key": "property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXejIxkJK4cRWKRITFldywY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_98b6b051-763d-4406-9be6-92e9701441c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Amici Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2023 W Guadalupe Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "Long-running counter-service joint offering New York-style slices, beer & wine in a modest setting.",
      "poi_long_description": "Diners say this pizza restaurant serves up delicious New York-style pizza, including the BBQ Chicken pizza and Vodka pizza, alongside tasty mozzarella sticks, fried ravioli, and wings. They also highlight the friendly and attentive staff, and the lively, family-friendly atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d3d1-7421-b06f-44838bdd2029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d3d1-7421-b06f-44838bdd2029",
        "storage_key": "property/6767906449167151/019d0218-d3d1-7421-b06f-44838bdd2029.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://amicipizzaaz.com/?y_source=1_MTI1NjY5MTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6063598070706671147&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amici-pizza",
      "poi_latitude": "33.3629127",
      "poi_longitude": "-111.8774701",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-361-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9435-7441-b70b-790942724446",
        "storage_key": "property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMeZPdJcHK4cRKw43qVE6JlQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_6aeb04fa-05c0-4d00-8b33-0877b195501c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Culinary Dropout",
      "poi_type": "Restaurants",
      "poi_address": "149 S Farmer Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "Cool, British-style gastropub chain with quirky decor, serving inventive cocktails & comfort food.",
      "poi_long_description": "People say this restaurant serves delicious pretzel bites, steak frites, and fried chicken. They also highlight the fun, lively atmosphere with games and live music, and the friendly, attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d49a-743c-9779-4bba28a9a699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d49a-743c-9779-4bba28a9a699",
        "storage_key": "property/6767906449167151/019d0218-d49a-743c-9779-4bba28a9a699.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.culinarydropout.com/locations/tempe-az/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7312887778953735745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culinary-dropout",
      "poi_latitude": "33.4286913",
      "poi_longitude": "-111.9440252",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 480-240-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9435-7441-b70b-790942724446",
        "storage_key": "property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1oNBSkJK4cRQS7VirCYfGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a002c524-a80d-46b6-a8b6-dea12a85460f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Four Peaks Brewing Company",
      "poi_type": "Restaurants",
      "poi_address": "1340 E 8th St, Tempe, AZ 85281, USA",
      "poi_short_description": "This working brewery also features a sizable eatery with patio seating & a menu of burgers & pizza.",
      "poi_long_description": "People say this restaurant offers a wide variety of delicious food, including burgers, pizza, and fish and chips, and a large selection of fresh, in-house brewed beers. They highlight the fun, lively atmosphere, and the friendly, attentive service. They also like the fair prices and generous portions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d497-77d7-a7d2-3f5f87bde3f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d497-77d7-a7d2-3f5f87bde3f4",
        "storage_key": "property/6767906449167151/019d0218-d497-77d7-a7d2-3f5f87bde3f4.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.fourpeaks.com/8th-street-pub",
      "poi_directions_map_url": "https://maps.google.com/?cid=2634640939298464657&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-peaks-brewing-company",
      "poi_latitude": "33.4195041",
      "poi_longitude": "-111.9158283",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-303-9967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9435-7441-b70b-790942724446",
        "storage_key": "property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJY9M3BPAIK4cRkSOWsfkfkCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c9a5a195-8b1d-4a63-a1fe-ff895a8f7936",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "JoJo Coffeehouse Breakfast & Brunch",
      "poi_type": "Restaurants",
      "poi_address": "3712 N Scottsdale Rd Suite 110, Scottsdale, AZ 85251, USA",
      "poi_short_description": "Airy eatery offering breakfast, waffles & brunch, plus cocktails, craft beers & live music.",
      "poi_long_description": "Diners say this breakfast restaurant serves up delicious breakfast tacos, cinnamon roll pancakes, and a standout coffee flight with a variety of flavors. They also highlight the quick and friendly service, lively atmosphere, and convenient location for exploring Old Town Scottsdale.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d3d1-7421-b06f-4ae42e54ba6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d3d1-7421-b06f-4ae42e54ba6e",
        "storage_key": "property/6767906449167151/019d0218-d3d1-7421-b06f-4ae42e54ba6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://jojocoffeehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1569342862372411265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jojo-coffeehouse-breakfast--brunch",
      "poi_latitude": "33.4906907",
      "poi_longitude": "-111.9263989",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 480-907-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9435-7441-b70b-790942724446",
        "storage_key": "property/6767906449167151/019d0218-9435-7441-b70b-790942724446.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN40pNzwLK4cRgZeAwgRtxxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_15c1b2bf-97ce-4eac-8727-fa11a9305c96",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Arizona Mills",
      "poi_type": "Shopping & Retail",
      "poi_address": "5000 S Arizona Mills Cir, Tempe, AZ 85282, USA",
      "poi_short_description": "Expansive indoor mall with 150+ retailers, restaurants & Arizona's largest IMAX theater.",
      "poi_long_description": "Visitors say this shopping center offers a wide variety of stores, including outlets, a movie theater with IMAX, an aquarium, and a Lego store. They also highlight the great deals and affordable prices, and many mention the family-friendly atmosphere with entertainment options for kids.\n\nSome reviews mention the safety can be a concern, especially at night.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d898-7269-bb05-98932e9d8863.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d898-7269-bb05-98932e9d8863",
        "storage_key": "property/6767906449167151/019d0218-d898-7269-bb05-98932e9d8863.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.simon.com/mall/arizona-mills",
      "poi_directions_map_url": "https://maps.google.com/?cid=2145774981481083229&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-mills",
      "poi_latitude": "33.383125",
      "poi_longitude": "-111.964485",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-491-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97ad-718f-9565-6a22bfe5a388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97ad-718f-9565-6a22bfe5a388",
        "storage_key": "property/6767906449167151/019d0218-97ad-718f-9565-6a22bfe5a388.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJh_lm4VkPK4cRXbEZE_pSxx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_52529e12-9388-474a-97eb-45faab365347",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Tempe Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 E Rio Salado Pkwy, Tempe, AZ 85288, USA",
      "poi_short_description": "Outdoor mall with national retailers, dining, live music on weekends & a play fountain for kids.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, restaurants, and entertainment options, including a movie theater, live music, and a splash pad. They highlight the fun and lively atmosphere, with frequent events and live music, and the convenient location near the Salt River with a beautiful trail. They also like the clean and well-maintained facilities, with misters to keep cool during hot weather.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d867-7784-8777-92f04bc6fafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d867-7784-8777-92f04bc6fafd",
        "storage_key": "property/6767906449167151/019d0218-d867-7784-8777-92f04bc6fafd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tempemarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16874235038211004953&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-marketplace",
      "poi_latitude": "33.4340695",
      "poi_longitude": "-111.9012791",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-966-9338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97ad-718f-9565-6a22bfe5a388.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97ad-718f-9565-6a22bfe5a388",
        "storage_key": "property/6767906449167151/019d0218-97ad-718f-9565-6a22bfe5a388.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz3KubQsJK4cRGVoEHV1TLeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_46056dbf-924f-49d8-87b9-560a4661a976",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "H Mart Mesa",
      "poi_type": "Shopping & Retail",
      "poi_address": "1919 W Main St, Mesa, AZ 85201, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "Shoppers say this Asian grocery store offers a wide variety of fresh produce, meats, and seafood, as well as a great selection of snacks, noodles, and ingredients for authentic Asian dishes. They also highlight the delicious food court with its diverse offerings, including Korean fried chicken and kimchi stew, and the convenient bakery with its sweet and savory treats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-d95d-734b-a448-fa11543c84de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-d95d-734b-a448-fa11543c84de",
        "storage_key": "property/6767906449167151/019d0218-d95d-734b-a448-fa11543c84de.webp",
        "width": 1104,
        "height": 621
      },
      "poi_business_url": "https://www.hmart.com/store/mesa-az-85201/f6d25951-7644-459c-addf-be97552f7808?has_food_court=true&message=",
      "poi_directions_map_url": "https://maps.google.com/?cid=485327551048822677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-mesa",
      "poi_latitude": "33.4134865",
      "poi_longitude": "-111.8729813",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 480-207-4560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97a2-7358-a889-0ebdc9de58c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97a2-7358-a889-0ebdc9de58c4",
        "storage_key": "property/6767906449167151/019d0218-97a2-7358-a889-0ebdc9de58c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6ruLuEJK4cRla_5F9Y6vAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_c79cdf99-048b-4137-a5ea-ded77ae6d0d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 S Ash Ave Ste 101, Tempe, AZ 85281, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce and high-quality products. They also highlight the convenient parking, helpful and friendly staff, and clean, organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/tempe?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=293300082475704867&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.4223669",
      "poi_longitude": "-111.9432648",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-456-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97a2-7358-a889-0ebdc9de58c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97a2-7358-a889-0ebdc9de58c4",
        "storage_key": "property/6767906449167151/019d0218-97a2-7358-a889-0ebdc9de58c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh7d33PQJK4cRI6KO_N4CEgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6d0b58c9-4d69-4e32-ac22-973389ce3c65",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Lee Lee International Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2025 N Dobson Rd, Chandler, AZ 85224, USA",
      "poi_short_description": "Spacious ethnic grocery with fresh produce, meat, seafood & foods imported from 30+ countries.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of products from around the world, including fresh produce, meat, seafood, and spices. They highlight the good prices and the fun, diverse shopping experience. They also like the friendly and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-da6a-7028-83af-acf7a3da99bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-da6a-7028-83af-acf7a3da99bb",
        "storage_key": "property/6767906449167151/019d0218-da6a-7028-83af-acf7a3da99bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://leeleesupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9770250931561996009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lee-lee-international-supermarkets",
      "poi_latitude": "33.3361505",
      "poi_longitude": "-111.8743382",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-899-2887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97a2-7358-a889-0ebdc9de58c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97a2-7358-a889-0ebdc9de58c4",
        "storage_key": "property/6767906449167151/019d0218-97a2-7358-a889-0ebdc9de58c4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG1SuUGkHK4cR6Z4uDnXnloc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_45070797-9e44-419e-9200-59f90446e9b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Arizona State University Tempe Campus",
      "poi_type": "Education",
      "poi_address": "1151 S Forest Ave, Tempe, AZ, USA",
      "poi_short_description": "Big public university known for its athletics programs, multiple campuses & its research facilities.",
      "poi_long_description": "Big public university known for its athletics programs, multiple campuses & its research facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-64b5-72f1-b109-419ed696051b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-64b5-72f1-b109-419ed696051b",
        "storage_key": "property/6767906449167151/019d0218-64b5-72f1-b109-419ed696051b.webp",
        "width": 1280,
        "height": 1113
      },
      "poi_business_url": "https://asu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7380961630776733747&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-state-university-tempe-campus",
      "poi_latitude": "33.4229975",
      "poi_longitude": "-111.9278306",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 855-278-5080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97b3-762a-b07c-a8dcdd09be3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97b3-762a-b07c-a8dcdd09be3f",
        "storage_key": "property/6767906449167151/019d0218-97b3-762a-b07c-a8dcdd09be3f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD1QzO9sIK4cRMzA8R39xbmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_11f6ab83-ca3d-4580-bbee-4a1abe83254d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Mesa Community College",
      "poi_type": "Education",
      "poi_address": "1833 W Southern Ave, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-639a-742e-8216-2170e263913b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-639a-742e-8216-2170e263913b",
        "storage_key": "property/6767906449167151/019d0218-639a-742e-8216-2170e263913b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mesacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6768540005639575714&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mesa-community-college",
      "poi_latitude": "33.3895475",
      "poi_longitude": "-111.8735409",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-461-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97b3-762a-b07c-a8dcdd09be3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97b3-762a-b07c-a8dcdd09be3f",
        "storage_key": "property/6767906449167151/019d0218-97b3-762a-b07c-a8dcdd09be3f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJh1-MyeQHK4cRotgqHEav7l0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9a735851-6aa5-4c6d-817e-ede4faab42c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Hayden Library",
      "poi_type": "Education",
      "poi_address": "300 E Orange St., Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://lib.asu.edu/hayden",
      "poi_directions_map_url": "https://maps.google.com/?cid=14453900414810150329&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hayden-library",
      "poi_latitude": "33.4190234",
      "poi_longitude": "-111.9346091",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-965-3605",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9f91-7409-8ec6-011e06742a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9f91-7409-8ec6-011e06742a52",
        "storage_key": "property/6767906449167151/019d0218-9f91-7409-8ec6-011e06742a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCWkre9sIK4cRuVWh49iRlsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c72b5ef0-ccdc-4806-a6be-213a8e90a0f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Tempe Public Library",
      "poi_type": "Education",
      "poi_address": "3500 S Rural Rd, Tempe, AZ 85282, USA",
      "poi_short_description": "Public library offering books and media for checkout, plus a cafe and programs.",
      "poi_long_description": "People say this public library has a great selection of books, a children's area with computer games, and meeting rooms. They also highlight the friendly and helpful staff, and the clean and organized environment.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.tempepubliclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13306252390981778904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-public-library",
      "poi_latitude": "33.39131450000001",
      "poi_longitude": "-111.9280626",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-350-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-97b3-762a-b07c-a8dcdd09be3f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-97b3-762a-b07c-a8dcdd09be3f",
        "storage_key": "property/6767906449167151/019d0218-97b3-762a-b07c-a8dcdd09be3f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR35tTZ8IK4cR2D0p0AxOqbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_da3947ac-0cbf-4cdd-b150-e552d570100f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Noble Library",
      "poi_type": "Education",
      "poi_address": "601 E Tyler Mall, Tempe, AZ 85281, USA",
      "poi_short_description": "University library with group and individual study rooms, plus a Starbucks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e028-771f-9dc8-c4a2a8b881a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e028-771f-9dc8-c4a2a8b881a8",
        "storage_key": "property/6767906449167151/019d0218-e028-771f-9dc8-c4a2a8b881a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lib.asu.edu/noble",
      "poi_directions_map_url": "https://maps.google.com/?cid=7208032230567471515&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "noble-library",
      "poi_latitude": "33.4199905",
      "poi_longitude": "-111.9306869",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-965-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9f91-7409-8ec6-011e06742a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9f91-7409-8ec6-011e06742a52",
        "storage_key": "property/6767906449167151/019d0218-9f91-7409-8ec6-011e06742a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj40Opt0IK4cRm2mKuB8TCGQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_b8916e2f-61cb-4ac6-9514-bda395451803",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Phoenix Zoo",
      "poi_type": "Entertainment",
      "poi_address": "455 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "125 acres of animal exhibits, including a children's area & petting zoo, plus a narrated tram ride.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including lions, tigers, giraffes, and monkeys, and has fun interactive experiences like camel rides and stingray petting. They highlight the beautiful scenery, spacious enclosures, and the opportunity to bring your own food. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e062-73a0-bb67-238e2ad0dc74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e062-73a0-bb67-238e2ad0dc74",
        "storage_key": "property/6767906449167151/019d0218-e062-73a0-bb67-238e2ad0dc74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenixzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7252865776953727344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phoenix-zoo",
      "poi_latitude": "33.4500374",
      "poi_longitude": "-111.9470063",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 602-286-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ3texLIOK4cRcBnqLv9ap2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_efef3dab-6d84-4ba2-899b-030677002152",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Sloan Park",
      "poi_type": "Entertainment",
      "poi_address": "2330 W Rio Salado Pkwy, Mesa, AZ 85201, USA",
      "poi_short_description": "Modest ballpark with concessions serving as the spring training home field for the Chicago Cubs.",
      "poi_long_description": "People say this ballpark offers a fun spring training experience with easy access and a nice park. They highlight the great Chicago-based food and beer, and the friendly and helpful staff. They also like the beautiful weather and great atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-7a64-77ce-a9ff-6103b0b57146.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-7a64-77ce-a9ff-6103b0b57146",
        "storage_key": "property/6767906449167151/019d0218-7a64-77ce-a9ff-6103b0b57146.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "https://www.mlb.com/cubs/sloan-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4728503286047011454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sloan-park",
      "poi_latitude": "33.4311077",
      "poi_longitude": "-111.881787",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 480-668-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9eda-743a-ab40-cdd138438239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9eda-743a-ab40-cdd138438239",
        "storage_key": "property/6767906449167151/019d0218-9eda-743a-ab40-cdd138438239.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ2EV8UkIK4cRfnIZnK8En0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_f254761d-66b5-4447-bd55-69ce8b661a34",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Mountain America Stadium",
      "poi_type": "Entertainment",
      "poi_address": "500 E Veterans Way, Tempe, AZ 85287, USA",
      "poi_short_description": "Expansive soccer arena on ASU's campus featuring raised stands & seat-back bleachers.",
      "poi_long_description": "People say this stadium offers a variety of food, drinks, and merchandise, and has elevators and golf carts for transportation. They highlight the electric atmosphere, the helpful and caring staff, and the great views from all seats. They also like the clean facilities and the convenient access via light rail.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://thesundevils.com/facilities/mountain-america-stadium-home-of-the-asu-sun-devils-frank-kush-field/12",
      "poi_directions_map_url": "https://maps.google.com/?cid=975906061454353698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountain-america-stadium",
      "poi_latitude": "33.426453",
      "poi_longitude": "-111.9325733",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 480-727-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9eda-743a-ab40-cdd138438239.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9eda-743a-ab40-cdd138438239",
        "storage_key": "property/6767906449167151/019d0218-9eda-743a-ab40-cdd138438239.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0RwU--MIK4cRIiUjb2Qdiw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_0e0feb86-db5a-4793-97fe-ddaa0f17d533",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Arizona Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "53 N Macdonald, Mesa, AZ 85201, USA",
      "poi_short_description": "Southwest life & art exhibits including dinosaur displays, a Hohokam village & gold panning.",
      "poi_long_description": "People say this natural history museum offers a wide variety of exhibits, including dinosaurs, fossils, Native American artifacts, and a gold panning area. They highlight the affordable prices, especially for families with lower incomes, and the kid-friendly atmosphere with interactive displays and a children's play area. They also like the helpful and passionate staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-6681-721f-993b-ca3de74bdbaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-6681-721f-993b-ca3de74bdbaa",
        "storage_key": "property/6767906449167151/019d0218-6681-721f-993b-ca3de74bdbaa.webp",
        "width": 1280,
        "height": 662
      },
      "poi_business_url": "https://www.azmnh.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8553743256923412926&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-museum-of-natural-history",
      "poi_latitude": "33.4166023",
      "poi_longitude": "-111.8336627",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 480-644-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9b7a-7431-bf0e-b04494b58c60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9b7a-7431-bf0e-b04494b58c60",
        "storage_key": "property/6767906449167151/019d0218-9b7a-7431-bf0e-b04494b58c60.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGcplxemnK4cRvhnQKCwAtXY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_44dc7533-7d42-4608-9fb6-4f89bc2c9382",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Mullett Arena",
      "poi_type": "Entertainment",
      "poi_address": "411 S Packard Dr, Tempe, AZ 85281, USA",
      "poi_short_description": "Smaller hockey venue also hosting concerts, with clean restrooms and friendly staff.",
      "poi_long_description": "People say this arena offers a variety of food and beer selections. They highlight the easy parking, convenient food options, and comfortable seating. They also like the friendly staff and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e051-76cc-bac5-4741f1522fce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e051-76cc-bac5-4741f1522fce",
        "storage_key": "property/6767906449167151/019d0218-e051-76cc-bac5-4741f1522fce.webp",
        "width": 1023,
        "height": 625
      },
      "poi_business_url": "http://mullettarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5617326154117862570&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mullett-arena",
      "poi_latitude": "33.4266174",
      "poi_longitude": "-111.9286578",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-564-3497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSaHJhmAJK4cRqtS0E2DA9E0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_092670bd-5af6-4fcd-b38d-1eb82cc0297a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1661 S Alma School Rd, Mesa, AZ 85210, USA",
      "poi_short_description": "Well-equipped fitness club featuring free weights, treadmills and group classes, plus basketball courts.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, and cardio options, as well as amenities like a movie theater, pool, and sauna. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.\n\nOther reviews mention the gym can be crowded during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e1c4-732b-878d-508f2d42c330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e1c4-732b-878d-508f2d42c330",
        "storage_key": "property/6767906449167151/019d0218-e1c4-732b-878d-508f2d42c330.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/mesa-alma-school-us-60/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13470119672115952446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.3845959",
      "poi_longitude": "-111.8557407",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 480-210-4880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSF1lB2oK4cRPvt4Wnl677o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a5b186a7-b3f0-401b-beda-647d61d7907c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Mountainside Fitness Tempe Marina Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Rio Salado Pkwy #102, Tempe, AZ 85281, USA",
      "poi_short_description": "Chain, featuring state-of-the-art exercise equipment, plus views of Tempe Town Lake and the Salt River.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and cardio options, and has a steam room. They highlight the convenient location with scenic views of the lake, the clean facilities, and the safe, shaded parking garage. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e500-75ce-b980-f6a84d947b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e500-75ce-b980-f6a84d947b45",
        "storage_key": "property/6767906449167151/019d0218-e500-75ce-b980-f6a84d947b45.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/tempe-marina-heights/?utm_source=GMB&utm_medium=Local&utm_campaign=Tempe&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9270648553778270050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-tempe-marina-heights",
      "poi_latitude": "33.4310649",
      "poi_longitude": "-111.9336089",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-664-6209",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw3Re0SYJK4cRYk9x3b31p4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b4ec7708-3193-4d0c-800e-2a58a3f5f6d1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "63 E Southern Ave, Tempe, AZ 85282, USA",
      "poi_short_description": "Clean gym offering classes, weights and cardiovascular equipment.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including a basketball court, pool, and sauna, and the facilities are clean and well-maintained. They also highlight the friendly and helpful staff, and the welcoming and positive atmosphere.\n\nOther reviews mention the gym can be busy during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e52f-7359-9164-d3011a9350be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e52f-7359-9164-d3011a9350be",
        "storage_key": "property/6767906449167151/019d0218-e52f-7359-9164-d3011a9350be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=38&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14282970337445433486&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.3916509",
      "poi_longitude": "-111.9381288",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 480-829-0622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIdgTFaUIK4cRjlDg9NhNN8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9ecf1c38-ad19-4d2a-99b8-8d58fba99f6f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Inspire Courts AZ",
      "poi_type": "Health and Wellness",
      "poi_address": "1090 N Fiesta Blvd, Gilbert, AZ 85233, USA",
      "poi_short_description": "Basketball gym offering practice sessions, courts and volleyball tournaments.",
      "poi_long_description": "People say this gym offers a variety of sports events and has a nice atmosphere with large fans.\n\nOther reviews mention the admission and parking fees can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-e568-71cb-9d1b-4cd17f29aa29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-e568-71cb-9d1b-4cd17f29aa29",
        "storage_key": "property/6767906449167151/019d0218-e568-71cb-9d1b-4cd17f29aa29.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.inspirecourtsaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11020540132396082551&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "inspire-courts-az",
      "poi_latitude": "33.3693466",
      "poi_longitude": "-111.8357009",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-221-7218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-1nFujeoK4cRd6VncNzS8Jg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6074ef15-c0f9-4a76-9de2-9b138183792f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Ability360 Sports & Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5031 E Washington St, Phoenix, AZ 85034, USA",
      "poi_short_description": "Large state-of-the-art & accessible fitness center with pools, spa, gym, basketball courts & track.",
      "poi_long_description": "People say this gym has a great rock wall and offers a variety of fitness programs. They also highlight the impressive and beautiful facility.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ability360.org/sports",
      "poi_directions_map_url": "https://maps.google.com/?cid=74284183542707757&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ability360-sports--fitness-center",
      "poi_latitude": "33.4451355",
      "poi_longitude": "-111.9737363",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-386-4566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtzcFXb4OK4cRLTZ-RBLpBwE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_44851eaf-a11a-4e75-9345-15b2dfdfa5d3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3122 S McClintock Dr, Tempe, AZ 85282, USA",
      "poi_short_description": "Chain fitness center at Southern Palms Shopping Center with cardio and weight-training equipment, plus tanning and massages.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines and weights, as well as amenities like hydro massage and red-light therapy. They also highlight the affordable membership options, convenient location, and clean facilities.\n\nOther reviews mention the maintenance can be poor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-6fd4-72ab-b7da-791a41b21f25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-6fd4-72ab-b7da-791a41b21f25",
        "storage_key": "property/6767906449167151/019d0218-6fd4-72ab-b7da-791a41b21f25.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tempe-east-az?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6301575222225454742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.3960332",
      "poi_longitude": "-111.9103271",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 480-361-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ5dcuIYIK4cRlsYmBkexc1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cd996c78-1247-47a5-b641-51896fa340f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Banner Desert Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 S Dobson Rd, Mesa, AZ 85202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-6a3e-71a7-8305-3f812bc1b5fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-6a3e-71a7-8305-3f812bc1b5fb",
        "storage_key": "property/6767906449167151/019d0218-6a3e-71a7-8305-3f812bc1b5fb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/mesa/banner-desert-medical-center?y_source=1_MTE5MDczNDgtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=614197494924193389&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-desert-medical-center",
      "poi_latitude": "33.3908762",
      "poi_longitude": "-111.8771772",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-412-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9b23-74cc-bc75-2380fa349ee4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9b23-74cc-bc75-2380fa349ee4",
        "storage_key": "property/6767906449167151/019d0218-9b23-74cc-bc75-2380fa349ee4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO1qJLOEHK4cRbS7kEl4Rhgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_1240d33e-4346-4f42-bc44-7f8b16f5802b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "HonorHealth Scottsdale Osborn Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7400 E Osborn Rd, Scottsdale, AZ 85251, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f0b6-72cd-8e62-e022b26ebb5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f0b6-72cd-8e62-e022b26ebb5e",
        "storage_key": "property/6767906449167151/019d0218-f0b6-72cd-8e62-e022b26ebb5e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.honorhealth.com/locations/hospitals/scottsdale-osborn-medical-center?utm_source=GMB&utm_medium=local&utm_campaign=Scottsdale_Osborn_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=13325143558524214027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "honorhealth-scottsdale-osborn-medical-center",
      "poi_latitude": "33.4884353",
      "poi_longitude": "-111.9229549",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 480-882-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9b23-74cc-bc75-2380fa349ee4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9b23-74cc-bc75-2380fa349ee4",
        "storage_key": "property/6767906449167151/019d0218-9b23-74cc-bc75-2380fa349ee4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UYuFsELK4cRC5vrgndr7Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e548eb11-429f-4060-bb32-b34fc640e425",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Desert Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Desert garden with 50,000 plants spread over 140 acres, also offering dining, a gift shop & library.",
      "poi_long_description": "People say this botanical garden offers a beautiful desert landscape with a wide variety of cacti, succulents, and desert plants, as well as a butterfly garden and a pond. They highlight the peaceful and relaxing atmosphere, and the well-maintained trails and water fountains. They also like the friendly and informative docents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-eac5-779a-9bf0-81db02116ff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-eac5-779a-9bf0-81db02116ff6",
        "storage_key": "property/6767906449167151/019d0218-eac5-779a-9bf0-81db02116ff6.webp",
        "width": 638,
        "height": 481
      },
      "poi_business_url": "https://dbg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2404053162249248023&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-botanical-garden",
      "poi_latitude": "33.4616795",
      "poi_longitude": "-111.944926",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 480-941-1225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIZ4tCFMJK4cRF10FJZ3pXCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_dae1d667-03a0-47dc-9c14-5d71175b4dfa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Papago Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Expansive hiking & picnicking area that includes the Phoenix Zoo & famed Hole-in-the-Rock formation.",
      "poi_long_description": "People say this park offers a variety of hiking trails, scenic views, and unique rock formations, including the popular \"Hole in the Rock.\" They highlight the easy access, ample parking, and family-friendly atmosphere, making it suitable for a quick stop or a longer visit. They also like the peaceful and natural vibe, perfect for a morning walk, sunset viewing, or photography.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13874092191196013735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "papago-park",
      "poi_latitude": "33.4536315",
      "poi_longitude": "-111.948693",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9b62-763f-a5a2-8161563965d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9b62-763f-a5a2-8161563965d8",
        "storage_key": "property/6767906449167151/019d0218-9b62-763f-a5a2-8161563965d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4MLk0wJK4cRp2RC_VatisA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_67b9086a-8616-4abc-be18-255af3332e15",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Hole in the Rock",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "625 N Galvin Pkwy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Landmark rock formation with multiple cavelike holes in the sandstone created by erosion.",
      "poi_long_description": "People say this hiking area offers a short, easy walk with beautiful views of the city and desert landscape, especially at sunset. They highlight the unique rock formation with a hole, perfect for photos and enjoying nature, and the ample parking and nearby restrooms. They also like the family-friendly atmosphere and the opportunity to see wildlife.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-ec3e-7678-b897-b8f6228003bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-ec3e-7678-b897-b8f6228003bc",
        "storage_key": "property/6767906449167151/019d0218-ec3e-7678-b897-b8f6228003bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.phoenix.gov/parks/trails/locations/papago-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=385298564104506413&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hole-in-the-rock",
      "poi_latitude": "33.4564869",
      "poi_longitude": "-111.9452606",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 602-495-5458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWuhyFEJK4cRLczqrQDbWAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_b0232e23-8f6d-47d7-8d96-e2c3d467c48f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Tempe Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "80 W Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "Local landmark features a splash playground, boating, a baseball diamond & other athletic fields.",
      "poi_long_description": "People say this park offers a variety of activities, including boat rentals, bike rentals, and scooter rentals, as well as walking trails and green spaces. They highlight the beautiful views, the busy and fun atmosphere, and the family-friendly environment. They also like the ample parking and the availability of paid parking garages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-ef07-73c9-acb6-bfe336691499.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-ef07-73c9-acb6-bfe336691499",
        "storage_key": "property/6767906449167151/019d0218-ef07-73c9-acb6-bfe336691499.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tempe.gov/Home/Components/FacilityDirectory/FacilityDirectory/176/3542",
      "poi_directions_map_url": "https://maps.google.com/?cid=366973538302800349&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tempe-beach-park",
      "poi_latitude": "33.4318454",
      "poi_longitude": "-111.9426228",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 480-350-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9b62-763f-a5a2-8161563965d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9b62-763f-a5a2-8161563965d8",
        "storage_key": "property/6767906449167151/019d0218-9b62-763f-a5a2-8161563965d8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XPvtSgJK4cR3bGBIH3AFwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_af8fcdd5-6a7f-468d-aab6-dd4952787f61",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Papago Golf Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5595 E Karsten Wy, Phoenix, AZ 85008, USA",
      "poi_short_description": "Public golf course with 18-holes & wedding venue open since 1963 with a clubhouse bar & grill.",
      "poi_long_description": "Public golf course with 18-holes & wedding venue open since 1963 with a clubhouse bar & grill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f2a3-77ca-a806-51045d2cc40c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f2a3-77ca-a806-51045d2cc40c",
        "storage_key": "property/6767906449167151/019d0218-f2a3-77ca-a806-51045d2cc40c.webp",
        "width": 1280,
        "height": 516
      },
      "poi_business_url": "https://www.papagogolfclub.com/?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1656885406848649145&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "papago-golf-club",
      "poi_latitude": "33.4612508",
      "poi_longitude": "-111.9607678",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 602-275-8428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0219-06e6-763e-b814-8ee0843ed329.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0219-06e6-763e-b814-8ee0843ed329",
        "storage_key": "property/6767906449167151/019d0219-06e6-763e-b814-8ee0843ed329.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJyZy28a4OK4cRuQe-vH9w_hY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d8f61865-b13c-490c-a1ae-041f13655d8a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Veterans Way/College Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4598022879801229784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "veterans-waycollege-ave",
      "poi_latitude": "33.426067",
      "poi_longitude": "-111.935959",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30kcm9gIK4cR2MGro3J1zz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_a25a6447-45ca-4b92-90cb-c35d1256bc49",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Gilbert Rd. / Main St.",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mesa, AZ 85204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f2af-7278-90f0-617ae190f682.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f2af-7278-90f0-617ae190f682",
        "storage_key": "property/6767906449167151/019d0218-f2af-7278-90f0-617ae190f682.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13494624434564559224&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gilbert-rd--main-st",
      "poi_latitude": "33.41533",
      "poi_longitude": "-111.790758",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wnmTiGmK4cRePGG92yJRrs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ec566663-a9b2-42e4-8fb3-57b420143991",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Mill Ave/3rd St",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f838-74f8-9108-9ab607f8d779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f838-74f8-9108-9ab607f8d779",
        "storage_key": "property/6767906449167151/019d0218-f838-74f8-9108-9ab607f8d779.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=639866828117951134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-ave3rd-st",
      "poi_latitude": "33.427453",
      "poi_longitude": "-111.9406986",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPes7bCgJK4cRnsKGcX1D4Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_9b02c9d2-6c4e-4abb-b893-14e1daddc9e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Dorsey Ln/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13215672625481361333&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dorsey-lnapache-blvd",
      "poi_latitude": "33.414769",
      "poi_longitude": "-111.916907",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3tuBO4IK4cRtaertTuAZ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_90e4a194-4b16-4548-be9f-e3b021adf68d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Price-101/Apache Blvd",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tempe, AZ 85288, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f87b-761c-a13e-3279bc245064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f87b-761c-a13e-3279bc245064",
        "storage_key": "property/6767906449167151/019d0218-f87b-761c-a13e-3279bc245064.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084548879482287968&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "price-101apache-blvd",
      "poi_latitude": "33.41482",
      "poi_longitude": "-111.888099",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjTEXD0IIK4cRYPf-OHo61Jk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_6114b7ca-f4d8-46aa-a2a7-f0b8888fcdda",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Amazon AZA3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1665 W Alameda Dr #101, Tempe, AZ 85282, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f9fb-7048-a89b-4b6a61b89a1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f9fb-7048-a89b-4b6a61b89a1f",
        "storage_key": "property/6767906449167151/019d0218-f9fb-7048-a89b-4b6a61b89a1f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10427779108402156537&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-aza3",
      "poi_latitude": "33.3982292",
      "poi_longitude": "-111.9650968",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJa0zIPK4cR-dOMsNnptpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9917e882-c897-4c0c-916e-f00a78ad8a6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Amazon Tempe Software Center PHX11",
      "poi_type": "Major Employers & Offices",
      "poi_address": "40 E Rio Salado Pkwy #600, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14824221418433897925&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-tempe-software-center-phx11",
      "poi_latitude": "33.4303077",
      "poi_longitude": "-111.9395738",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-266-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtR3mFyYJK4cRxWV9hdY2us0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5baa3d85-f232-43fc-86d0-47f38ef5e9e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "State Farm at Marina Heights",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 E Rio Salado Pkwy, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.statefarm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601884207670731235&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-farm-at-marina-heights",
      "poi_latitude": "33.4299472",
      "poi_longitude": "-111.9305218",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-733-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN_x42CAJK4cR46GFITMJOxY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fc0f25ed-476a-4940-9b17-3da29eb93c7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "PHX12 - Amazon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 S Mill Ave, Tempe, AZ 85281, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-f9bb-70ed-9d98-87670b327acc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-f9bb-70ed-9d98-87670b327acc",
        "storage_key": "property/6767906449167151/019d0218-f9bb-70ed-9d98-87670b327acc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2197275368270750170&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "phx12---amazon",
      "poi_latitude": "33.4291744",
      "poi_longitude": "-111.9406587",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxaYTxPgJK4cR2mF-R05Kfh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0b2bd73b-061f-4f27-a0d8-04923889e6ec",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "poi_name": "Amazon AZA7",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1665 W Alameda Dr Suite 125, Tempe, AZ 85282, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-fec7-754f-a29f-f5846d1a044e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0218-fec7-754f-a29f-f5846d1a044e",
        "storage_key": "property/6767906449167151/019d0218-fec7-754f-a29f-f5846d1a044e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.amazon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14143606551000623893&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "amazon-aza7",
      "poi_latitude": "33.3990165",
      "poi_longitude": "-111.9657042",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0218-9433-7310-90e0-52d357e12e1a",
        "storage_key": "property/6767906449167151/019d0218-9433-7310-90e0-52d357e12e1a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ7MCeiYPK4cRFatH2zgvSMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5f0f4ba7466ab3ae7441159a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c3db205097a281d236b65baa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a963471465c8c8c7a2594eba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bddb1cf542f8b5bbf43c8d88",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c6f84c20f3154ebd9a6410fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6824804432b6103f367b164d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_d07ce9d1-8c26-4e49-93e8-df50c343d36e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "rating": "5.0",
      "name": "Daniel Torres",
      "text": "I’m so glad that I was able to live here, the location was perfect since my job is in Scottsdale and the freeway is close by. I usually go to Tempe marketplace to grab food it’s just down the street and when In my free time I take advantage of the gym onsite. Claudia was always there for me if I had any questions and she was always helpful, maintenance was fast and always enjoyed the resident events, Highly recommend these apartments!!",
      "date": "2026-01-14",
      "title": ""
    },
    {
      "id": "custom_65162198-9d60-4405-bd8c-4eb842f1eb20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "rating": "5.0",
      "name": "Erika Summers",
      "text": "The staffing here are amazing and very hands on. Especially Angelica, if we have concerns about anything she takes care of it immediately and accordingly. The Maintenance staff are also very quick and efficient. Thank you so much to all of you for making living here a good experience",
      "date": "2025-10-24",
      "title": ""
    },
    {
      "id": "custom_18ec8b0e-a150-4fc6-a63e-3dabf4a5503d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "rating": "5.0",
      "name": "Rosa Reyes",
      "text": "Pala Mesa Community is fun  did a fun Christmas gathering with lots of fun prizes.\n\nClaudia in our Leasing office always helps me and answer all my questions. I like seeing her every 1st of the month to pay me monthly rent.  Happy new year.",
      "date": "2026-01-03",
      "title": ""
    },
    {
      "id": "custom_350eec56-97b2-4f81-8edd-f9371f01ac99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "rating": "5.0",
      "name": "Itai Matope",
      "text": "The apartments are very homely and reasonably affordable. There is lots of space if you dont want to be cramped. Claudia gives world class service...she tries to give you the best deal and one thing that stood out to me was the designs she did in the apartment to welcome us...that was awesome!",
      "date": "2025-10-22",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_d7740dc5-70b4-4a36-b404-8590bb733bea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c1-f9a8-76ef-8140-2535727b9f3c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern reception area with comfortable seating and a large chandelier.",
        "public_id": "019d08c1-f9a8-76ef-8140-2535727b9f3c",
        "storage_key": "property/6767906449167151/019d08c1-f9a8-76ef-8140-2535727b9f3c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pala Mesa | Office",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oWKwqycU7rJ"
    },
    {
      "id": "custom_0761979c-5fb8-4509-9d82-aeec83cbd5de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c1-f990-72c8-a15d-2de797b22123.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "019d08c1-f990-72c8-a15d-2de797b22123",
        "storage_key": "property/6767906449167151/019d08c1-f990-72c8-a15d-2de797b22123.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pala Mesa | Gym",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Z55F7BEdhUp"
    },
    {
      "id": "custom_25ca67a9-a02a-4596-b070-49e385dfbfb1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c2-027e-706a-a153-28391fd00661.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Weight room with dumbbells and weight racks.",
        "public_id": "019d08c2-027e-706a-a153-28391fd00661",
        "storage_key": "property/6767906449167151/019d08c2-027e-706a-a153-28391fd00661.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pala Mesa | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JturXduRs4d"
    },
    {
      "id": "custom_48b32cba-8da9-4ac3-aab1-9a0c4a7a8011",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c1-f87a-7292-8984-ba5ae03e8869.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with white cabinets, appliances, and a double sink.",
        "public_id": "019d08c1-f87a-7292-8984-ba5ae03e8869",
        "storage_key": "property/6767906449167151/019d08c1-f87a-7292-8984-ba5ae03e8869.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pala Mesa | Peak Unit | 1bd 1bd",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sjDJZi4jTcf"
    },
    {
      "id": "custom_e5ade926-6a8d-4157-9591-8e75d0c5f6f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c1-f92e-726a-b340-ecb0b59a0bfe.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen counter with sink, dishwasher, and cabinets. View to living area.",
        "public_id": "019d08c1-f92e-726a-b340-ecb0b59a0bfe",
        "storage_key": "property/6767906449167151/019d08c1-f92e-726a-b340-ecb0b59a0bfe.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pala Mesa | The Ridge | 2BR, 1BA - 838 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oPwQXfrYHLY"
    },
    {
      "id": "custom_59edb870-69ae-49c8-bc41-7675f80d80ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167151/019d08c2-0376-70b8-82c1-aa7ca0e42ff5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Modern kitchen with light wood cabinets, double sink, and adjacent dining area.",
        "public_id": "019d08c2-0376-70b8-82c1-aa7ca0e42ff5",
        "storage_key": "property/6767906449167151/019d08c2-0376-70b8-82c1-aa7ca0e42ff5.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pala Mesa | The Summit | 2BR, 2BA - 952 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FDbcxLzfGT1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019d8e62-ee47-7352-a57c-d9adc859c625",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Pala Mesa Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-mesa-az",
      "search_query": "apartments with in-unit laundry in Mesa AZ",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Mesa, AZ",
      "h2_subtitle": "Find modern apartments with in-unit laundry features. Make Pala Mesa in Mesa, AZ, your new home today!",
      "page_copy": "Welcome to Pala Mesa, your ideal destination for modern living in Central Mesa. Our apartments with in-unit laundry in Mesa, AZ, offer the convenience you’ve been dreaming of. No more hauling your laundry down the street or waiting on machines—it’s all right here, at home.\n\nBeyond the comfort of in-unit laundry, Pala Mesa offers fabulous amenities like a sparkling spa, a pet play area, and a gated community for added security. With a dishwasher and ceiling fans in select units, you’ll enjoy convenience and style. Nestled in Maricopa County, our community is designed to meet all your living needs in a serene setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Mesa, AZ",
      "seo_description": "Discover Pala Mesa apartments in Mesa, AZ, with in-unit laundry and top amenities. Perfect for convenient, modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-central-mesa",
      "search_query": "air-conditioned apartments Central Mesa",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments in Central Mesa",
      "h2_subtitle": "Enjoy comfortable air-conditioned apartments at Pala Mesa. Located in the heart of Central Mesa, experience cool living all year round.",
      "page_copy": "Pala Mesa welcomes you to a refreshing lifestyle with our air-conditioned apartments in Central Mesa. Beat the Arizona heat and enjoy a cool, comfortable home in this desirable neighborhood.\n\nLocated in the vibrant area of Central Mesa, Pala Mesa not only offers air-conditioned comfort but also a wide range of amenities. Relax in our community spa, entertain your furry friend in the pet play area, and enjoy the security of a gated community. Whether you're relaxing under a ceiling fan or using your in-unit dishwasher, Pala Mesa provides a contemporary living experience in Maricopa County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Central Mesa",
      "seo_description": "Stay cool in Pala Mesa’s air-conditioned apartments. Located in Central Mesa with top amenities for stress-free living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "gated-apartments-with-pools-maricopa-county",
      "search_query": "gated apartments with pools in Maricopa County",
      "category": "Amenity",
      "h1_title": "Gated Apartments with Pools in Maricopa County",
      "h2_subtitle": "Explore gated apartments with pools at Pala Mesa. Enjoy luxury living with added security in Maricopa County.",
      "page_copy": "Discover the charm of living at Pala Mesa, offering gated apartments with pools in Maricopa County. Our community provides a serene and secure environment with amenities designed for a balanced lifestyle.\n\nPala Mesa is more than just a place to live; it's a place to thrive. Relax in our refreshing spa, enjoy the pet play area for your furry companions, and experience the modern convenience of appliances like dishwashers and ceiling fans in select units. Located in the heart of vibrant Central Mesa, our gated community ensures peace of mind alongside luxury living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gated Apartments with Pools in Maricopa County",
      "seo_description": "Experience secure living at Pala Mesa with gated apartments and refreshing pool amenities in Maricopa County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-mesa-lightrail",
      "search_query": "dog park apartments near Mesa Lightrail",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Mesa Lightrail",
      "h2_subtitle": "Live at Pala Mesa, where dog park apartments meet convenience. Located near the Mesa Lightrail for easy commutes.",
      "page_copy": "Pala Mesa combines pet-friendly living with unmatched convenience, offering dog park apartments near the Mesa Lightrail. Perfect for pet owners, our apartments provide a dedicated pet play area where your furry friends can roam freely.\n\nStrategically situated in Central Mesa, Pala Mesa ensures that commuting is never a hassle with the Mesa Lightrail nearby. Our gated community features modern attractions like a spa, in-unit dishwashers, and ceiling fans in select units, providing a holistic living experience in Maricopa County. Make every day more convenient and enjoyable at Pala Mesa.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Mesa Lightrail",
      "seo_description": "Find pet-friendly convenience at Pala Mesa, offering dog park apartments near Mesa Lightrail for stress-free commuting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "apartments-with-covered-parking-85201",
      "search_query": "apartments with covered parking 85201",
      "category": "Amenity",
      "h1_title": "Apartments with Covered Parking in 85201",
      "h2_subtitle": "Find the ideal home at Pala Mesa with covered parking. Conveniently located in the 85201 area, offering modern amenities.",
      "page_copy": "At Pala Mesa, we offer apartments with covered parking in the 85201 ZIP code area, ensuring your vehicle remains protected year-round. Our community is designed with convenience and comfort in mind.\n\nLocated in Central Mesa, Pala Mesa is a gated community featuring a range of amenities including a relaxing spa, a pet play area, and modern interiors equipped with dishwashers and ceiling fans in select units. Discover the perfect blend of convenience and comfort at Pala Mesa, where covered parking is just one of the many features designed to enhance your living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Covered Parking in 85201",
      "seo_description": "Discover Pala Mesa apartments with covered parking in Mesa, AZ 85201. Enjoy modern amenities and a prime Mesa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-mesa-az",
      "search_query": "one bedroom apartments in Mesa AZ",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Mesa, AZ",
      "h2_subtitle": "Discover spacious one bedroom apartments at Pala Mesa. Located in vibrant Mesa, AZ, offering both comfort and convenience.",
      "page_copy": "Pala Mesa presents one bedroom apartments in Mesa, AZ that perfectly blend style and functionality. Each unit is thoughtfully designed to provide a comfortable living environment with modern conveniences.\n\nSituated in Central Mesa, our community offers a variety of amenities like a refreshing spa and pet play area. Living at Pala Mesa means having access to in-unit dishwashers and ceiling fans too, enhancing your daily living experience. With gated entry and convenient access to local attractions, these apartments provide the ideal setting for your Mesa lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Mesa, AZ",
      "seo_description": "Find your ideal home with Pala Mesa's one bedroom apartments in Mesa, AZ. Enjoy modern amenities and great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167151",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-maricopa-county",
      "search_query": "two bedroom floorplans Maricopa County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Maricopa County",
      "h2_subtitle": "Explore spacious two bedroom floorplans at Pala Mesa. Situated in Maricopa County, offering modern amenities and a prime location.",
      "page_copy": "Pala Mesa features thoughtfully designed two bedroom floorplans ideal for anyone looking to settle in Maricopa County. Our spacious apartments offer a perfect blend of comfort and style, catering to diverse lifestyle needs.\n\nLocated in Central Mesa, our community provides amenities like a relaxing spa and a dedicated pet play area. With in-unit features such as dishwashers and ceiling fans in select units, our gated community ensures a modern and convenient living environment. Whether you're a growing family or professionals seeking extra space, our two bedroom layouts offer flexibility and functionality.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans in Maricopa County",
      "seo_description": "Find spacious two bedroom floorplans at Pala Mesa in Maricopa County. Enjoy modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309037461"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6234280007"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5MLRV4P9"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "f765a24d-91d8-4a3c-ab6e-335b0b2a7307"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/1e188a83-e672-4f7d-b2d5-63cd9e218971/app.js?property=1e188a83-e672-4f7d-b2d5-63cd9e218971&propertyName=Pala+Mesa&channelUuid=c2490c13-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47568032099"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjdhZ1pGUTRmVi9EMGMxQm9xZzJTRmc9PSIsInZhbHVlIjoiMTUvM05qZisyVnBNQTZyeWlkUGdZZz09IiwibWFjIjoiMjIzZjVjNzg2ZWEyMzUxODg2ZmMzM2E4ZjFlNmVkMzViYzJiZDkyNzMwODE2ZTQ3MDU5NzIwNTJiOTM2N2Y4MCJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309037461",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6234280007",
  "custom_google_gtm_id": "GTM-5MLRV4P9",
  "custom_rollout_phase": "Phase 1",
  "custom_rentgrata_token": "f765a24d-91d8-4a3c-ab6e-335b0b2a7307",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/1e188a83-e672-4f7d-b2d5-63cd9e218971/app.js?property=1e188a83-e672-4f7d-b2d5-63cd9e218971&propertyName=Pala+Mesa&channelUuid=c2490c13-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47568032099",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjdhZ1pGUTRmVi9EMGMxQm9xZzJTRmc9PSIsInZhbHVlIjoiMTUvM05qZisyVnBNQTZyeWlkUGdZZz09IiwibWFjIjoiMjIzZjVjNzg2ZWEyMzUxODg2ZmMzM2E4ZjFlNmVkMzViYzJiZDkyNzMwODE2ZTQ3MDU5NzIwNTJiOTM2N2Y4MCJ9",
  "custom_audioeye_site_id": "d1490b98-cb41-48c1-8dd3-a9eeed21bd09",
  "custom_audioeye_site_hash": "de0591e271ff6af48af397c17442b9ec"
};

export const generatedAt = '2026-10-27T17:30:46.185Z';
